<script>
	const _ = require('underscore');
	const utilities = require('utilities');
	const model = require('model/model');
	const classUtilities = require('utilities/classUtilities');
	const deleteClass = classUtilities.deleteClass;

	const { authenticateWithGoogleClassroom, isKnownGoogleClass, isInvalidatingGoogleError } = require('utilities/googleClassroomUtilities');

	module.exports = {
		components: {
			message: require('components/message.vue').default
		},
		modelData: ['localGCAccessToken', 'gcClassList'],
		data: function () {
			return {
				clazz: null,
				callback: function () {},
				loading: false
			};
		},
		methods: {
			onDeleteClick: function (clazz) {
				let callback = this.callback;
				let token = this.localGCAccessToken;

				let params = _.assign({}, clazz, { token });

				this.loading = true;
				deleteClass(params)
					.then(() => {
						this.close();
						callback();
					})
					.catch(error => {
						if (isInvalidatingGoogleError(error)) {
							model.set('localGCAccessToken', '');
						}
					})
					.finally(() => (this.loading = false));
			},
			close: function () {
				utilities.closeModals();
			},
			authenticateWithGoogle() {
				authenticateWithGoogleClassroom();
			}
		},
		computed: {
			name: function () {
				if (this.clazz && this.clazz.name) {
					return this.clazz.name;
				}
				return '';
			},
			classCode: function () {
				if (this.clazz && this.clazz.classCode) {
					return this.clazz.classCode;
				}
				return '';
			},
			gcTokenMismatch() {
				const gcid = this.clazz && this.clazz.gcid;

				return gcid && this.gcClassList && !isKnownGoogleClass(gcid);
			},
			needsGoogleAuth() {
				const gcid = this.clazz ? this.clazz.gcid : null;
				const token = this.localGCAccessToken;
				/* No GCA check needed - inaccessible in GCA */

				return !!(gcid && (!token || this.gcTokenMismatch));
			},
			disableButtons() {
				return this.needsGoogleAuth || this.loading;
			}
		},
		mounted() {
			let self = this;
			self.$subscribe('modal-opened', (modalId, opts) => {
				if (modalId !== 'modal-delete-class') {
					return true; // let some other handler take this
				}

				if (opts.clazz) {
					this.clazz = opts.clazz;
				}
				if (opts.callback) {
					this.callback = opts.callback;
				}
				return false;
			});

			self.$subscribe('modal-closed', (modalId, opts) => {
				if (modalId !== 'modal-delete-class') {
					return true; // let some other handler take this
				}

				this.clazz = null;
				this.callback = function () {};
				return false;
			});
		}
	};
</script>
<template>
	<modal
		ref="modal"
		id="modal-delete-class"
		:ok="false"
		:centered="true">
		<template slot="header-container">
			<h2>Delete Class Confirmation</h2>
		</template>
		<div
			slot="content"
			class="delete-class-modal-body">
			<h3>Are you sure you want to delete class &ldquo;{{ name }}&rdquo; (Code {{ classCode }})?</h3>
			<p>Once deleted, you and your students will no longer be able to access the class, its assignments or the assignment results.</p>
			<div
				class="margin-top-bottom-medium"
				v-if="needsGoogleAuth">
				<message
					v-if="gcTokenMismatch"
					class="margin-top-xs"
					type="error">
					Please authenticate the Google account used to manage this Classroom
				</message>
				<button
					class="button margin-top-small"
					@click="authenticateWithGoogle">
					Authenticate with Google Classroom
				</button>
			</div>
			<div class="margin-top-bottom-medium">
				<button
					class="button -outline"
					:class="{
						disabled: disableButtons
					}"
					@click="close"
					:disabled="disableButtons">
					Do Not Delete
				</button>
				<button
					class="button -danger enter-action"
					:class="{
						disabled: disableButtons,
						'-in-progress': loading
					}"
					@click="onDeleteClick(clazz)"
					:disabled="disableButtons">
					Delete
				</button>
			</div>
		</div>
	</modal>
</template>
